import React from 'react';
import {
  Box,
  Typography,
  Paper,
  Button,
  Chip,
  Card,
  CardContent,
  CardActions,
} from '@mui/material';
import {
  EmojiEvents as TrophyIcon,
  CheckCircle as AcceptIcon,
  Cancel as DeclineIcon,
} from '@mui/icons-material';
import { getInvitationStatusDisplay, INVITATION_STATUS } from '../services/qualifierInvitationService';
import LinkifiedText from './LinkifiedText';

export default function ChampionshipInvitationPreview({
  level,
  skaterName = 'Skater Name',
  rank = 1,
  totalPoints = 0,
  message = '',
  variant = 'qualifier',
}) {
  const isWaitlist = variant === 'waitlist';
  const statusDisplay = getInvitationStatusDisplay(isWaitlist ? INVITATION_STATUS.WAITLIST : INVITATION_STATUS.SENT);

  return (
    <Box>
      <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1, color: 'text.secondary' }}>
        {isWaitlist
          ? 'Preview — runner-up / waitlist message'
          : 'Preview — qualifier invitation'}
      </Typography>
      <Paper
        elevation={0}
        sx={{
          p: 2.5,
          borderRadius: 3,
          border: '2px solid',
          borderColor: isWaitlist ? 'grey.400' : 'warning.main',
          bgcolor: isWaitlist ? 'grey.50' : 'warning.50',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
          <TrophyIcon sx={{ fontSize: 28, color: isWaitlist ? 'text.secondary' : 'warning.main' }} />
          <Box>
            <Typography variant="h6" sx={{ fontWeight: 700, lineHeight: 1.2 }}>
              {isWaitlist ? 'Championship Waitlist' : 'Championship Invitations'}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {isWaitlist
                ? 'Your skater is a runner-up for the championship.'
                : 'Your skater(s) have qualified for the championship!'}
            </Typography>
          </Box>
        </Box>

        {!isWaitlist && (
          <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1.5, color: 'warning.dark' }}>
            Action Required
          </Typography>
        )}

        <Card sx={{ border: '1px solid', borderColor: isWaitlist ? 'divider' : 'warning.main' }}>
          <CardContent sx={{ pb: 1 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1 }}>
              <Box>
                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                  {skaterName}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {level} - Rank #{rank}
                </Typography>
              </Box>
              <Chip label={statusDisplay.label} color={statusDisplay.color} size="small" />
            </Box>
            <Typography variant="body2" sx={{ mt: 1 }}>
              Total Points: <strong>{totalPoints}</strong>
            </Typography>
            {message?.trim() ? (
              <LinkifiedText text={message} variant="body2" sx={{ mt: 2 }} />
            ) : (
              <Typography variant="body2" color="text.secondary" sx={{ mt: 2, fontStyle: 'italic' }}>
                Your invitation message will appear here.
              </Typography>
            )}
          </CardContent>
          {!isWaitlist && (
            <CardActions sx={{ px: 2, pb: 2 }}>
              <Button variant="contained" color="success" startIcon={<AcceptIcon />} disabled>
                Accept Spot
              </Button>
              <Button variant="outlined" color="error" startIcon={<DeclineIcon />} disabled>
                Decline
              </Button>
            </CardActions>
          )}
        </Card>
      </Paper>
    </Box>
  );
}
